import '.a{display:flex;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.aj{gap:0.5rem;}.ssr-plugin'
import '.ap{cursor:pointer;}.ssr-plugin'
import '.e0{padding:0.75rem;}.ssr-plugin'
import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.ak{border:var(--blue-border);}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.dn{transition:background-color 0.2s ease;}.ssr-plugin'
import '.d1{width:2.5rem;}.ssr-plugin'
import '.d2{height:2.5rem;}.ssr-plugin'
import '.id{color:var(--shades-blue-700);}.ssr-plugin'
import '.ie{font-size:0.9rem;}.ssr-plugin'
import '.ax{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a b m n aj ap e0 ad ak ae dn"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="d1 d2 a n b id"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="ie id ax"
        >
          {label}
        </span>
      </styled.button>
    )
}